var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages)?_c('vl-layer-vector',{attrs:{"zIndex":160}},[_c('vl-source-vector',[_vm._l((_vm.messages),function(message,id){return _c('vl-feature',{key:id,attrs:{"properties":{
                    type: 'message',
                    code: message.type,
                    id: message.id,
                    tooltip: _vm.tooltip(message),
                     }}},[_c('vl-geom-point',{attrs:{"coordinates":[message.longitude, message.latitude]}})],1)}),_c('vl-style-func',{attrs:{"function":_vm.styleFunc()}})],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }